import React from 'react';
import classNames from 'classnames';
const DropdownItem = ({ className, borderBottom, disabled, size, iconPosition = 'right', link, icon, text, onClick, onClickLink, }) => {
    let resultClassName = classNames('ac-dropdown-item ', borderBottom ? 'border-bottom ' : '', disabled ? 'disabled ' : '', className);
    let item = (React.createElement(React.Fragment, null,
        iconPosition === 'left' && icon && icon,
        text,
        iconPosition === 'right' && icon && icon));
    if (link) {
        return (React.createElement("a", { href: link, className: resultClassName, onClick: onClickLink, role: 'menuitem' }, item));
    }
    return (React.createElement("button", { className: resultClassName, role: 'menuitem', type: 'button', onClick: () => {
            onClick && onClick();
        } }, item));
};
export { DropdownItem };
//# sourceMappingURL=DropdownItem.js.map